import React, { useEffect, useState } from 'react';
import { CurrentUserContext } from '../../context/CurrentUserContext';
import PopupWithForm from '../PopupWithForm/PopupWithForm';
import { useTranslation } from '../../utils/hooks/translateHook';
import hide from '../../images/hide.png';
import view from '../../images/view.png';
import './LoginPopup.css';

function LoginPopup ( {isOpen, onClose, onLogin, isLoading, isMobile, handleForgotPasswordClick = () => {}}) {
  const currentUser = React.useContext(CurrentUserContext);
  const t = useTranslation();

  const [formData, setFormData ] = useState({ email: '', password: ''});
  const [formErrors, setFormErrors] = useState ({ email: false, password: false});
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const handleChange = (e) => {
    const { name, value, validity, validationMessage } = e.target;
    setFormData((prev) => ({...prev, [name]: value }));
    setFormErrors((prev) => ({...prev, [name]: validity.valid ? false : validationMessage}))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const { email, password } = formData;
    onLogin({ email, password });  
  }
  useEffect(() => {
    const valid = Object.keys(formErrors).every((key) => formErrors[key] === false && formData[key]);
    setIsButtonEnabled(valid);
  }, [formErrors, formData]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen]);
 
  return (
    <PopupWithForm
      title="SIGN IN"
      name="signin"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      buttonText={isLoading ? 'Signing in...' : 'SIGN IN'}
      isButtonEnabled={isButtonEnabled}
      isLoggedIn={false}
      buttonClassName="login"
      closeButtonClassName="login-close"
      handleForgotPasswordClick={handleForgotPasswordClick}
    >
      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('email')}</p>
        <input
          className="popup__input"
          name="email"
          type="email"
          placeholder="Enter email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <span className="popup__input-error">{formErrors.email}</span>
      </label>

{/*       <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('password')}</p>
        <input
          className="popup__input"
          name="password"
          type="password"
          placeholder="Enter password"
          value={formData.password}
          onChange={handleChange}
          required
        />
      </label> */}
      <label className="popup__formfield">
        <p className="popup__formfield__labeltype">{t('password')}</p>
        <div style={{ position: 'relative' }}>
          <input
            className="popup__input"
            name="password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="button" onClick={() => setShowPassword((prev) => !prev)} className="visibility">
            {/* {showPassword ? 'Hide' : 'Show'} */}
          <img
              src={showPassword ? hide : view}
              alt={showPassword ? 'Hide password' : 'Show password'}
              style={{ width: '20px', height: '20px' }}
            />
          </button>
        </div>
      </label>

      <p onClick={handleForgotPasswordClick}>{t('forgotpassword')}</p>
    </PopupWithForm>
  )
}



export default LoginPopup;